module.exports = "pegasus_template/assets/background-patterns/theme5_theme.jpg";